<template>
    <div>
        <div class="accordion-container" :class="isClosed ? '' : 'show-less'">
            <div class="accordion-header" @click="handleClosed">
                <img class="gift-icon" src="/images/fr_new_home/Atom/Icon/gift-icon-recap.png" alt="gift icon">
                <div>
                    <h2 class="pack-pretitle">je €2 pakket</h2>
                    <h3 class="pack-title">Je ontvangt het aanbod <br>
                        van 2€/2 maanden + je welkomstcadeau naar keuze</h3>
                </div>
                <span :class="['accordion-btn', 'show-more', { 'is-open': !isClosed }]"></span>
            </div>
        </div>
        <div class="form-pack">
            <div :class="isClosed ? 'is-closed' : ''" class="accordion-body">
                <ul class="pack-list">
                    <li>
                        <img class="list-check" src="/images/fr_new_home/Atom/Icon/LIST/green-check.svg">
                        <div>
                            <img class="pack-img" :src="form_side_image">
                            <strong>Je welkomstgeschenk
                                uit meer dan 150 keuzes</strong>
                        </div>
                    </li>
                    <li>
                        <img class="list-check" src="/images/fr_new_home/Atom/Icon/LIST/green-check.svg">Je magazines op
                        papier en digitaal
                    </li>
                    <li>
                        <img class="list-check" src="/images/fr_new_home/Atom/Icon/LIST/green-check.svg">Onbeperkte juridische, fiscale en technische advies
                    </li>
                    <li>
                        <img class="list-check" src="/images/fr_new_home/Atom/Icon/LIST/green-check.svg">12 praktische gidsen naar keuze
                    </li>
                </ul>
            </div>
        </div>
    </div>

</template>

<script>
import image_mixin from "./mixins/image_mixin";

export default {
    name: "PackComponentAccordionCookbook",
    mixins: [
        image_mixin
    ],
    computed: {
        isIban() {
            return this.$store.get('general_data/current_step') === 'iban'
        }
    },
    data() {
        return {
            isClosed: true,
        };
    },
    methods: {
        handleClosed() {
            this.isClosed = !this.isClosed;
        },
    },
    mounted() {
    }
}
</script>

<style lang="scss" scoped>

</style>
